import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as api from '../api/mail.api';

export const useMailboxes = () => {
  return useQuery({ queryKey: ['mail','mailboxes'], queryFn: api.fetchMailboxes, staleTime: 1000 * 60 * 30 });
};

export const useCreateMailbox = () => {
  const q = useQueryClient();
  return useMutation({ mutationFn: api.createMailbox, onSuccess: () => q.invalidateQueries(['mail','mailboxes']) });
};

export const useDeleteMailbox = () => {
  const q = useQueryClient();
  return useMutation({ mutationFn: api.deleteMailbox, onSuccess: () => q.invalidateQueries(['mail','mailboxes']) });
};

export const useMailboxHealth = (id) => {
  return useQuery({ queryKey: ['mail','mailbox','health',id], queryFn: () => api.mailboxHealth(id), enabled: !!id });
};

export const useMailboxSync = () => {
  const q = useQueryClient();
  return useMutation({ mutationFn: api.mailboxSync, onSuccess: (_, mailboxId) => { q.invalidateQueries(['mail','folders',mailboxId]); q.invalidateQueries(['mail','messages']); } });
};
